import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import HelpPlanningCta from '../HelpPlanningCta';
import PlanningGuideCta from '../PlanningGuideCta';

export const CtaModule = props => {
  const {
    funeralHome: {
      profileData: {displayPrePlanningForm, prePlanningFormValue},
    },
  } = props;

  if (displayPrePlanningForm && prePlanningFormValue === 0) {
    return <PlanningGuideCta />;
  }

  if (displayPrePlanningForm && prePlanningFormValue === 1) {
    return <HelpPlanningCta />;
  }

  return null;
};

CtaModule.propTypes = {
  funeralHome: PropTypes.object,
};

CtaModule.defaultProps = {
  funeralHome: {},
};

const mapStateToProps = state => ({
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(CtaModule);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/CtaModule/index.js